export function initials(n = "") {
  return n.split(" ").map((x) => x[0]).slice(0, 2).join("").toUpperCase();
}

export function durLabel(min) {
  if (!min) return "0 min";
  const h = Math.floor(min / 60);
  const m = min % 60;
  if (h && m) return `${h} t ${m} min`;
  if (h) return `${h} t`;
  return `${m} min`;
}

export const FAST_SAKER = [
  { title: "Godkjenning av innkalling og saksliste", category: "Åpning", duration_min: 5, proposal: "Innkalling og saksliste godkjennes.", meta: "Fast sak · alle møter" },
  { title: "Godkjenning av protokoll fra forrige møte", category: "Åpning", duration_min: 5, meta: "Fast sak · alle møter" },
  { title: "Økonomi og risikostyring", category: "Fast sak", duration_min: 20, meta: "Fast sak · alle møter" },
  { title: "Orientering om drift", category: "Fast sak", duration_min: 15, meta: "Fast sak · alle møter" },
  { title: "Strategigjennomgang", category: "Strategi", duration_min: 30, meta: "Fast sak · siste i Q3" },
  { title: "Eventuelt", category: "Avslutning", duration_min: 5, meta: "Fast sak · alle møter" },
];
